import React, { useContext, useState } from "react"
import { NextButton } from "../NextButton"
import { CenterPiece, Footer, Main, Previous } from "../styles"
import { Slide } from "./Slide"
import { Players } from "../players/Players"
import GameContext from "../../../Context/GameContext"
import getMediaUrl from '../../../utils/mediaUrl'

export const Slides = props => {
  const { gameProps } = useContext(GameContext)
  const { content, handleEnd, labels, backgroundImage } = props //todo = third button (eg: skip global intro + download results)
  const [currentSlide, setCurrentSlide] = useState(0)
  const isFirstSlide = currentSlide === 0
  const isLastSlide =
    content.length === 0 || currentSlide === content.length - 1
  const [pending, setPending] = useState(false)

  const handleNext = () => {
    setCurrentSlide(currentSlide + 1)
  }

  const handlePrevious = () => {
    setCurrentSlide(currentSlide - 1)
  }

  const onEnd = () => {
    setPending(true)
    handleEnd()
  }

  const backgroundImageUrl = backgroundImage
    ? getMediaUrl(gameProps?.strapiUrl, backgroundImage?.url)
    : null
  const imageAlt = backgroundImage?.alternativeText || ""

  return (
    <Main backgroundImage={backgroundImageUrl} role="img" aria-label={imageAlt}>
      <CenterPiece>
        <Slide slide={content[currentSlide]} />
      </CenterPiece>
      <Footer>
        <Previous
          onClick={handlePrevious}
          disabled={isFirstSlide}
          children={labels.previous}
        />
        <Players />
        <NextButton
          onClick={isLastSlide ? onEnd : handleNext}
          children={isLastSlide && labels.end ? labels.end : labels.next}
          pending={pending}
          disabled={pending}
        />
      </Footer>
    </Main>
  )
}
